import { fromJS, List } from 'immutable';

import { failAction, startAction, successAction } from 'actions/actionTypes';

import { DELETE_DEVICE, GET_DEVICES } from 'actions/devices';

const defaultState = fromJS({
    ids: [],
    submitting: false,
    params: {
        page: 1,
    },
    totalPages: 0,
});
const devices = (state = defaultState, action) => {
    switch (action.type) {
        case startAction(GET_DEVICES):
            return state.set('submitting', true);
        case successAction(GET_DEVICES): {
            let ids = List();
            if (action.params.page > 1) {
                ids = state.get('ids');
            }
            const newIds = fromJS(action.response.normalizedData.result).filterNot(item => (
                ids.includes(item)
            ));
            ids = ids.concat(newIds);
            return state.set('submitting', false)
                .set('ids', ids)
                .set('params', fromJS(action.params))
                .set('totalPages', action.response.data.meta.totalPages);
        }
        case failAction(GET_DEVICES):
            return state.set('submitting', false);
        case successAction(DELETE_DEVICE):
            return state.updateIn(['ids'], (list = List()) => list.filterNot(item => item === action.deviceId));
        default:
            return state;
    }
};

export default devices;
